import React from 'react'
import { colorsTypes } from 'utils'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import type { FinderFolderItem } from 'store/models'
import { testProps } from 'utils/test/qaData'

import * as s from './FolderComponent.module.scss'

interface IFolderComponentProps {
  folder: FinderFolderItem
  onClick?: (folder: FinderFolderItem) => void
}

const FolderComponent: React.FC<IFolderComponentProps> = ({ folder, onClick }) => (
  <div
    className={s.root}
    {...testProps({ el: 'link', name: folder.name })}
    onClick={() => onClick?.(folder)}
  >
    <Icon
      className={s.icon}
      name='iconFillFolder'
      size={KitSize.S}
      style={{ color: folder.color || colorsTypes.purpure }}
    />
    <div className={s.content} style={folder.isArchived ? { filter: 'grayscale(100%)' } : {}}>
      <Typography rows={1}>{folder.nodeName || folder.name}</Typography>
    </div>
  </div>
)

export default FolderComponent
